import { SafeHtml } from "@angular/platform-browser";

export interface PlansModel {
    id?: string;
    nameBr?: string;
    nameEn?: string;
    order?: number;
    priceBr?: number;
    priceEn?: number;
    description?: string;
    includesAt?: Array<{ name: string; }>
    idealFor?: SafeHtml;
    planSelected?: boolean;
    indicated?: boolean;
    icon?: string;
    pid?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface PlanUser {
    id?: string;
    name?: string;
    pid?: string;
}

export enum PlansType {
    FREE_BR = 'gratuito',
    TRAINING_BR = 'formação',
    PLACEMENT_BR = 'placement',
    FREE_EN = 'free',
    TRAINING_EN = 'training',
    PLACEMENT_EN = 'placement',
}